import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "firebaseConfig"; // Certifique-se de que o caminho esteja correto
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton"; // Importado para o botão "X"
import CloseIcon from "@mui/icons-material/Close"; // Ícone "X"
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import logoBranca from "assets/images/logos/LogoSemFundo.png";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleOpenModal = (message) => {
    setModalMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = async () => {
    if (!email.includes("@")) {
      handleOpenModal("Por favor, insira um e-mail válido.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      handleOpenModal("E-mail de redefinição de senha enviado com sucesso! Verifique sua caixa de entrada.");
    } catch (error) {
      handleOpenModal("Erro ao enviar e-mail de redefinição. Verifique se o e-mail está correto.");
    }
  };

  return (
    <MDBox
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        overflow: "hidden",
        backgroundColor: "#F7F9FC",
      }}
    >
      {/* Seção Esquerda - Decorativa (com Logomarca) */}
      <MDBox
        sx={{
          display: { xs: "none", md: "flex" },
          width: { md: "50%" },
          background: "linear-gradient(135deg, #1E3A8A 0%, #6D28D9 100%)",
          alignItems: "flex-start",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Conteúdo */}
        <MDBox sx={{ position: "relative", zIndex: 10, maxWidth: "500px", pt: 4, px: 6, mt: 4, color: "white" }}>
          {/* Logomarca */}
          <MDBox textAlign="center" mb={2}>
            <Link to="/">
              <img
                src={logoBranca}
                alt="Logomarca"
                width="200"
                height="200"
                style={{ transition: "transform 0.3s ease", "&:hover": { transform: "scale(1.05)" } }}
              />
            </Link>
          </MDBox>

          <MDTypography
            variant="h2"
            fontWeight="bold"
            mb={4}
            sx={{
              fontFamily: "'Roboto Slab', serif",
              letterSpacing: "1px",
              background: "linear-gradient(90deg, #FFFFFF 0%, #E2E8F0 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            A Liberdade Financeira Começa Aqui
          </MDTypography>
          <MDTypography
            variant="body1"
            mb={6}
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              lineHeight: "1.6",
            }}
          >
            Assuma o controle das suas finanças com nossas ferramentas abrangentes e insights personalizados para o seu
            sucesso financeiro.
          </MDTypography>

          {/* Lista de Recursos */}
          <MDBox component="ul">
            {[
              "Painel Personalizado",
              "Gestão Inteligente de Orçamento",
              "Acompanhamento de Metas Financeiras",
              "Relatórios Financeiros Detalhados",
            ].map((feature, index) => (
              <MDBox key={index} component="li" display="flex" alignItems="center" mb={3}>
                <MDBox
                  sx={{
                    width: "10px",
                    height: "10px",
                    bgcolor: "rgba(255, 255, 255, 0.8)",
                    borderRadius: "50%",
                    mr: 3,
                  }}
                />
                <MDTypography
                  variant="body2"
                  sx={{
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "1rem",
                  }}
                >
                  {feature}
                </MDTypography>
              </MDBox>
            ))}
          </MDBox>
        </MDBox>
      </MDBox>

      {/* Seção Direita - Formulário de Redefinição de Senha */}
      <MDBox
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 4, md: 8 },
        }}
      >
        <MDBox sx={{ width: "100%", maxWidth: "450px" }}>
          {/* Título e Subtítulo */}
          <MDBox textAlign="center" mb={8}>
            <MDTypography
              variant="h3"
              fontWeight="bold"
              color="dark"
              mb={2}
              sx={{
                fontFamily: "'Roboto Slab', serif",
                letterSpacing: "0.5px",
                background: "linear-gradient(90deg, #1E3A8A 0%, #6D28D9 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Redefinir Senha
            </MDTypography>
            <MDTypography variant="body1" color="text.secondary" sx={{ fontSize: "1.1rem", opacity: 0.8 }}>
              Insira seu e-mail para receber as instruções
            </MDTypography>
          </MDBox>

          {/* Formulário */}
          <Card
            sx={{
              p: 6,
              borderRadius: "20px",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
            }}
          >
            <MDBox
              component="form"
              role="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <MDBox mb={4}>
                <MDTypography
                  variant="body2"
                  fontWeight="medium"
                  mb={1}
                  display="block"
                  sx={{ color: "#1E3A8A", fontSize: "0.9rem" }}
                >
                  Email
                </MDTypography>
                <MDInput
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      borderRadius: "12px",
                      backgroundColor: "#F8FAFC",
                      height: "48px",
                      border: "1px solid #E2E8F0",
                      transition: "all 0.3s ease",
                      "&:hover": { borderColor: "#6D28D9" },
                    },
                    "& input": { color: "#1E3A8A", fontSize: "1rem" },
                  }}
                />
              </MDBox>

              <MDButton
                type="submit"
                fullWidth
                sx={{
                  background: "linear-gradient(90deg, #3B82F6 0%, #8B5CF6 100%)",
                  color: "#FFFFFF",
                  borderRadius: "12px",
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: "medium",
                  fontSize: "1rem",
                  boxShadow: "0 4px 15px rgba(59, 130, 246, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "linear-gradient(90deg, #2563EB 0%, #7C3AED 100%)",
                    boxShadow: "0 6px 20px rgba(59, 130, 246, 0.4)",
                    transform: "translateY(-2px)",
                  },
                  "&:disabled": {
                    color: "#FFFFFF",
                    opacity: 0.6,
                  },
                }}
              >
                Enviar
              </MDButton>

              <MDBox textAlign="center" mt={6}>
                <MDTypography variant="body2" sx={{ color: "grey.600", fontSize: "0.9rem" }}>
                  Voltar para{" "}
                  <Link
                    to="/authentication/sign-in"
                    style={{
                      color: "#6D28D9",
                      fontWeight: "medium",
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    Login
                  </Link>
                </MDTypography>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>

      {/* Modal de Alerta */}
      <Modal open={showModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
            p: 4,
            textAlign: "center",
            position: "relative", // Para posicionar o botão "X"
          }}
        >
          {/* Botão "X" no canto superior direito */}
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#1E3A8A",
              "&:hover": {
                color: "#6D28D9",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <MDTypography variant="h6" sx={{ color: "#1E3A8A" }}>
            {modalMessage}
          </MDTypography>
        </Box>
      </Modal>
    </MDBox>
  );
}

export default ResetPassword;
